import React, { useMemo } from 'react';
import styled from 'styled-components';
import { FlexMiddle } from '@ubeya/shared-web/components';

const Wrapper = styled(FlexMiddle)`
  justify-content: flex-end;
`;

const AdminApprovalRenderer = ({
  rowData: { isExternal, clientApproved, adminApproved, summarized },
  columnData: { mappedAdmins }
}) => {
  const adminData = useMemo(
    () =>
      adminApproved
        ? mappedAdmins[adminApproved.adminId]
        : clientApproved && isExternal
        ? mappedAdmins[clientApproved.adminId]
        : null,
    [adminApproved, clientApproved, isExternal, mappedAdmins]
  );

  const approved = adminApproved || clientApproved;

  if (summarized || !approved || !adminData) {
    return <></>;
  }

  return <Wrapper>{`${adminData.firstName} ${adminData.lastName}`}</Wrapper>;
};

export default AdminApprovalRenderer;
